module.exports = __webpack_public_path__ + "static/img/logo_28.cdfb2b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_28.png
// module id = JSU1
// module chunks = 1